import { Button } from "antd";
import React, { useState } from "react";

import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";



const RichEditor = ({ backBtn, updateBtn, value, onChange }) => {
  return (
    <div style={{ maxWidth: "900px", margin: "auto" }}> {/* Giới hạn khung hiển thị */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Button onClick={backBtn}>Quay lại</Button>
        <h2>Chỉnh sửa bài viết</h2>
        <Button onClick={updateBtn}>Cập nhật</Button>
      </div>

      {/* SunEditor */}
      <div style={{
        height: "80vh", // Chiều cao tối đa có thể chiếm
        overflow: "hidden", // Tránh tràn layout
        border: "1px solid #ccc",
        borderRadius: "5px"
      }}>
        <SunEditor
          setContents={value}
          onChange={onChange}
          setOptions={{
            height: "100%", // Để trình chỉnh sửa mở rộng tự nhiên
            minHeight: "500px", // Đảm bảo có đủ không gian
            width: "100%",
            buttonList: [
              ["undo", "redo"],
              ["bold", "italic", "underline", "strike"],
              ["align", "list", "table"],
              ["image", "video", "link"],
              ["fontSize", "formatBlock", "preview"]
            ],
          }}
        />
      </div>

      {/* CSS bổ sung nếu cần */}
      <style>{`
        .sun-editor {
          max-width: 900px; 
          width: 100%;
        }
        .sun-editor .se-wrapper {
          height: auto !important; /* Đảm bảo không bị bó cứng */
          overflow-y: auto !important; /* Cho phép cuộn */
        }
        .sun-editor-editable img {
          max-width: 100% !important;
          height: auto !important;
          display: block;
          margin: 10px auto;
        }
      `}</style>
    </div>
  );
};

export default RichEditor;